import { render, staticRenderFns } from "./AdminStatusPanel.vue?vue&type=template&id=471db500&scoped=true"
import script from "./AdminStatusPanel.vue?vue&type=script&lang=js"
export * from "./AdminStatusPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminStatusPanel.vue?vue&type=style&index=0&id=471db500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471db500",
  null
  
)

export default component.exports